<template>
  <!--<v-main>-->
  <BaseCrudTable ref="basetable"
                 :headers="headers"
                 :hide-actions="hideActions"
                 :disabled="disabled"
                 :is-async="isAsync"
                 :is-loading="isLoading"
                 :is-searchable="isSearchable"
                 :is-alert="isAlert"
                 :table-data-external="tableDataExternal"
                 :enable-export="enableExport"
                 :show-head="showHead"
                 :keep-show-btn="true"
                 :is-dragable="false"
                 :is-db-update="isDbUpdate"
                 table-name="Участники"
                 endpoint="customers"
                 @editClicked="editClick"
                 @onDelete="onDelete"
                 @deleteClicked="onDelete">
    <template v-slot:editVals>
      <v-col>
        <v-form ref="form"
                v-model="valid"
                lazy-validation
                @submit.prevent="submit">
          <v-container>
            <v-snackbar
              v-model="snackbar"
              :timeout="5000"
              top
              style="z-index: 1000"
              color="success">
              {{ snackbarText }}
              <template v-slot:action="{ attrs }">
                <v-btn
                  v-bind="attrs"
                  text
                  @click="snackbar = false">
                  Close
                </v-btn>
              </template>
            </v-snackbar>
            <v-col>
              <v-card-text>
                <v-row justify="center">
                  <v-btn icon @click="qrScan=!qrScan">
                    <v-icon>mdi-qrcode-scan</v-icon>
                  </v-btn>
                </v-row>
                <v-row justify="center">
                  <qrCodeComponent v-if="qrScan"
                                   :fullscreen-mode="false"
                                   :qr-scan.sync="qrScan"
                                   @decode="onDecode" />
                </v-row>
                <v-row v-for="(input,k) in inputs" :key="k">
                  <v-text-field
                    :ref="`cust-${k}`"
                    :key="`cust-${k}`"
                    v-model.trim="input.full_code"
                    :rules="codeRules"
                    :error-messages="errorMessages"
                    label="Код"
                    placeholder="код участника"
                    hint="Пример кода: АС240191АММ"
                    required
                    class="capitalised-input"
                    clearable
                    @keydown.enter.prevent="add(k)" />
                  <div class="text-center"
                       style="padding-top: 15px">
                    <v-menu
                      v-model="input.menu"
                      :close-on-content-click="false"
                      :nudge-width="200"
                      offset-x>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          outlined
                          color="teal"
                          icon
                          v-on="on">
                          <v-icon> mdi-dots-horizontal</v-icon>
                        </v-btn>
                      </template>

                      <v-card>
                        <v-list-item avatar>
                          <v-list-item-content>
                            <v-list-item-title>Дополнительная информация о клиенте</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider />
                        <v-list>
                          <v-list-item>
                            <!--                            <v-list-item-action>-->
                            <v-text-field v-model.trim="input.phone" label="Телефон" />
                            <!--                            </v-list-item-action>-->
                          </v-list-item>
                          <v-list-item>
                            <!--                            <v-list-item-action>-->
                            <v-text-field v-model.trim="input.hint" label="Просьба" />
                            <!--                            </v-list-item-action>-->
                          </v-list-item>
                        </v-list>
                        <v-card-actions>
                          <v-spacer />
                          <v-btn color="primary" text @click="input.menu = false">
                            Сохранить
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-menu>
                  </div>
                  <!--                  <v-layout align-center>-->
                  <!--                    <v-checkbox v-model="enabled" hide-details class="shrink mr-2" />-->
                  <!--                    <v-text-field :disabled="!enabled" label="Телефон" />-->
                  <!--                    <v-text-field :disabled="!enabled" label="Просьба" />-->
                  <!--                  </v-layout>-->
                  <div style="padding-top: 15px">
                    <v-btn v-show="k == inputs.length-1"
                           text
                           icon
                           color="green"
                           @click.prevent="add(k)">
                      <v-icon>add</v-icon>
                    </v-btn>
                  </div>
                  <div style="padding-top: 15px">
                    <v-btn v-show="k || ( !k && inputs.length > 1)"
                           text
                           icon
                           color="red"
                           @click="remove(k)">
                      <v-icon>remove</v-icon>
                    </v-btn>
                  </div>
                </v-row>
              </v-card-text>
            </v-col>
            <v-card-actions>
              <v-btn text @click="close()">
                Отмена
              </v-btn>
              <v-spacer />
              <v-slide-x-reverse-transition>
                <v-tooltip
                  v-if="formHasErrors"
                  left />
              </v-slide-x-reverse-transition>
              <v-btn :disabled="!valid"
                     color="primary"
                     text
                     type="submit">
                Подтвердить
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-form>
      </v-col>
    </template>
    <template v-slot:additionalButton>
      <v-expand-transition>
        <v-card
          v-show="show">
          <v-text-field ref="auto_amount"
                        v-model="auto_amount"
                        label="Количество"
                        type="number" />
          <v-select ref="selectedAudience"
                    v-model="auto_sex"
                    :items="['М','Ж']"
                    single-line
                    menu-props="auto"
                    label="Пол"
                    required />
        </v-card>
      </v-expand-transition>
      <v-btn
        icon
        class="mb-2"
        @click="show = !show">
        <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </v-btn>
      <v-btn
        color="primary"
        dark
        icon
        @click="generateCodes">
        <v-icon>mdi-flash-auto</v-icon>
      </v-btn>
      <v-btn
        icon
        @click="$emit('clearCustomers')">
        <v-icon>mdi-cancel</v-icon>
      </v-btn>
      <!--      <qrCodeComponent ref="qrCodeElement" mode="generate" />-->
    </template>
  </BaseCrudTable>
</template>

<script>
import BaseCrudTable from '../base/BaseCrudTable'

export default {
  name: "CustomersTable",
  components: {BaseCrudTable},
  props: {
    isAsync: {
      type: Boolean,
      default: true
    },
    isDbUpdate: {
      type: Boolean,
      default: true
    },
    isLoading: {
      type: Boolean,
      default: true
    },
    isSearchable: {
      type: Boolean,
      default: true
    },
    hideActions: {
      type: Boolean,
      default: false
    },
    showHead: {
      type: Boolean,
      default: true
    },
    tableHeaders: {
      type: Array,
      default: () => [
        {text: 'Дата рождения', value: 'date_of_birth', align: 'left', sortable: true},
        {text: 'Полный код', value: 'full_code', align: 'left', sortable: true},
        {text: 'Пол', value: 'sex', align: 'left', sortable: true},
        {text: 'id', value: 'id', align: 'left', sortable: true, class: ['d-none']},
        {text: 'Actions', value: 'actions', align: 'left', sortable: false}
      ]
    },
    isAlert: {
      type: Boolean,
      default: false
    },
    tableDataExternal: {
      type: Array,
      default: () => []
    },
    enableExport: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  /* eslint-disable */
  data () {
    return {
      show:false,
      auto_amount: 5,
      auto_sex: 'М',
      fullscreenMode:true,
      snackbar:false,
      snackbarText:'',
      qrScan: false,
      fav: true,
      menu: false,
      phone: null,
      hints: null,
      headers: this.tableHeaders,
      editIndex: null,
      enabled: false,
      editItem: {
        full_code: '',
        sex: 'М',
        phone:'',
        hint:'',
        menu: false
      },
      valid: false,
      dialog: false,
      errorMessages: '',
      formHasErrors: false,
      inputs: [{'full_code': '', 'sex': '', 'phone':'', 'hint':'', 'menu':false}],
      codeRules: [
        /* eslint-disable */
        v => !!v || 'Поле обязательно',
        v => !!v && !(/[^а-я0-9.,!?'"\s]/i.test(v)) || 'Значение должно быть на русском языке',

        v => !!v && !(/^[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/.test(v.substring(0, 3))) && isNaN(v.substring(0, 3)) && v.length >= 2 || 'Первые два значения кода должны быть буквами',
        v => !!v && this.isValidDate(v.substring(2, 8)) && v.length >= 8 || 'Неверный формат даты рождения',
        v => !!v && !(/^[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/.test(v.substring(8, 11))) && isNaN(v.substring(8, 11)) && v.length >= 10 || 'Последние два значения кода должны быть буквами',
        v => !!v && ['М', 'Ж'].includes(v.toUpperCase().substring(10, 11)) && isNaN(v.substring(10, 11)) && v.length >= 11 ||
          'Последнее значение должно быть либо М либо Ж',
        v => !!v && v && v.length === 11 || 'Код состоит из оддинадцати символов'
        // v => !(this.inputs.map(element => {
        //     if (element.full_code) return element.full_code.toUpperCase() === v.toUpperCase()
        //     }).filter(x => x==true).length > 1)||'Нельзя вводить одного участника несколько раз'

      ],
      dateRules: [
        v => !!v || 'Поле обязательно',
        v => this.isValidDate(v) || 'Неверная дата'
      ],
      moreCustomers: true
    }
  },
  computed: {
    form () {
      return this.inputs
    }
  },
  watch: {
    tableHeaders (newValue) {
      this.headers = newValue
    }
  },
  methods: {
  generateCodes () {
    this.show = false
    let dict = {'date':this.date, 'sex':this.auto_sex, 'amount':this.auto_amount, 'customers':this.customers}
    this.$emit('generateCodes', dict)
  },
    printQR () {
      this.$refs['qrCodeElement'].printQR(this.$refs['basetable'].$refs["datatable"].$refs["sortableTable"].filteredItems)
        this.dialogSubmit = false
        this.dialogReportDuplicate = false
        },

    onDecode(newVal) {
      if ( this.fullscreenMode) {
        this.snackbarText = newVal+' успешно добавлен!'
        this.snackbar = true
      }
      newVal = {'full_code': newVal.trim(), 'sex': newVal.trim().toUpperCase().slice(-1), 'phone':'', 'hint':'', 'menu':false}
      if (this.inputs.length===1 && this.inputs[0]['full_code']==='') {
        this.inputs[0] = newVal
      }
      else this.inputs.push(newVal)
    },
    editClick (newVal, index) {
      this.moreCustomers = false
      let vm = this
      this.editIndex = index
      if (vm.inputs[vm.editIndex]) {
        vm.inputs[vm.editIndex]['full_code'] = newVal['full_code'].toUpperCase()
        vm.inputs[vm.editIndex]['sex'] = newVal['full_code'].toUpperCase().slice(-1)
        vm.inputs[vm.editIndex]['phone'] = newVal['phone']
        vm.inputs[vm.editIndex]['hint'] = newVal['hint']
      } else {
        vm.inputs[0]['full_code'] = newVal['full_code'].toUpperCase()
        vm.inputs[0]['sex'] = newVal['full_code'].toUpperCase().slice(-1)
        vm.inputs[0]['phone'] = newVal['phone']
        vm.inputs[0]['hint'] = newVal['hint']
        vm.inputs[0]['id'] = newVal['id']

      }
    },
    clear () {
      this.$refs['basetable'].clear()
      // this.inputs = {'full_code':'', 'sex':''}
    },
    onDelete (index) {
      this.$emit('deleteCustomersList', index)
    },
    isValidDate (s) {
      // var bits = s.split('-');
      var d = new Date(s.substring(2, 4) + '/' + s.substring(0, 2) + '/' + s.substring(4))
      return !!(d && (d.getMonth() + 1) == s.substring(2, 4) && d.getDate() == Number(s.substring(0, 2)))
    },
    add (k) {
      this.inputs.push({'full_code': '', 'sex': '', 'phone':'', 'hint':'', 'menu':false})
      this.$nextTick(() => {
        this.$refs[`cust-${k + 1}`][0].$refs.input.focus()
      })
    },
    remove (index) {
      this.inputs.splice(index, 1)
    },
    submit () {
      this.formHasErrors = !this.$refs.form.validate()
      let vm = this
      Object.keys(vm.form).forEach(f => {
        if (!vm.form[f]) {
          vm.formHasErrors = true
        }
      })
      if (!this.formHasErrors) {
        if (this.isAsync) this.$refs["basetable"].save(JSON.stringify(this.inputs))
        this.inputs.forEach(el => {delete el['menu']})
        this.$emit('updateCustomersList', this.inputs, this.editIndex)
        this.editIndex = null

        this.$refs.form.resetValidation()
        this.$refs.form.reset()

        this.close()

      }
    },
    close () {
      this.$refs["basetable"].close()
      this.inputs.splice(1, this.inputs.length)
      this.$set(this.inputs[0], 'full_code', '')
    }
  }


}
</script>

<style lang="scss">

.capitalised-input input {
  text-transform: uppercase !important;
}

.hidden-header /deep/ {
  display: none !important;
}

</style>



// WEBPACK FOOTER //
// src/components/tables/CustomersTable.vue